export const BRAND = {
  BLUE: 'blue',
  MASTER: 'master',
  LAB: 'lab',
  MANTO: 'manto'
}
